<div [editableInStoryblok]="_editable()">
	<vp-video [showControls]="showControls()" [vimeoId]="vimeoId()" />
</div>
